import {BasisOfQuotation} from "../models/QuoteRecord";

export const BasisOfQuotationDescriptionPipe = "basisOfQuotationDescription";
export const BasisOfQuotationCodePipe = "basisOfQuotationCode";

export type BasisOfQuotationPipe = (basisOfQuotation: BasisOfQuotation) => string;

export function basisOfQuotationDescriptionPipe(): BasisOfQuotationPipe {
    return (basis: BasisOfQuotation) => {
        switch (basis) {
            case BasisOfQuotation.CALL_DUE:
                return "Call Due";
            case BasisOfQuotation.CALL_PAID:
                return "Call Paid";
            case BasisOfQuotation.CONDITIONAL_TRADING:
                return "Conditional Trading";
            case BasisOfQuotation.CUM_BONUS_ISSUE:
                return "Cum Bonus Issue";
            case BasisOfQuotation.EX_BONUS_ISSUE:
                return "Ex Bonus Issue";
            case BasisOfQuotation.CUM_CAPITAL_RETURN:
                return "Cum Capital Return";
            case BasisOfQuotation.EX_CAPITAL_RETURN:
                return "Ex Capital Return";
            case BasisOfQuotation.CUM_DIVIDEND:
                return "Cum Dividend";
            case BasisOfQuotation.EX_DIVIDEND:
                return "Ex Dividend";
            case BasisOfQuotation.CUM_ENTITLEMENT:
                return "Cum Entitlement";
            case BasisOfQuotation.EX_ENTITLEMENT:
                return "Ex Entitlement";
            case BasisOfQuotation.CUM_EQUAL_ACCESS_SCHEME:
                return "Cum Equal Access Scheme";
            case BasisOfQuotation.EX_EQUAL_ACCESS_SCHEME:
                return "Ex Equal Access Scheme";
            case BasisOfQuotation.CUM_INTEREST:
                return "Cum Interest";
            case BasisOfQuotation.EX_INTEREST:
                return "Ex Interest";
            case BasisOfQuotation.CUM_PRIORITY:
                return "Cum Priority";
            case BasisOfQuotation.EX_PRIORITY:
                return "Ex Priority";
            case BasisOfQuotation.CUM_RIGHTS_ISSUE:
                return "Cum Rights Issues";
            case BasisOfQuotation.EX_RIGHTS_ISSUE:
                return "Ex Rights Issues";
            case BasisOfQuotation.CUM_TAKEOVER_OFFER:
                return "Cum Takeover Offer";
            case BasisOfQuotation.EX_TAKEOVER_OFFER:
                return "Ex Takeover Offer";
            case BasisOfQuotation.NEW_EX_INTEREST:
                return "New Ex Interest";
            case BasisOfQuotation.PROTECTION_AVAILABLE:
                return "Protection Available";
            case BasisOfQuotation.PROTECTION_UNAVAILABLE:
                return "Protection Unavailable";
            case BasisOfQuotation.RECONSTRUCTED:
                return "Reconstructed";
            default:
                return basis;
        }
    };
}

export function basisOfQuotationCodePipe(): BasisOfQuotationPipe {
    return (basis: BasisOfQuotation) => {
        switch (basis) {
            case BasisOfQuotation.CALL_DUE:
                return "CL";
            case BasisOfQuotation.CALL_PAID:
                return "CP";
            case BasisOfQuotation.CONDITIONAL_TRADING:
                return "CT";
            case BasisOfQuotation.CUM_BONUS_ISSUE:
                return "CB";
            case BasisOfQuotation.EX_BONUS_ISSUE:
                return "XB";
            case BasisOfQuotation.CUM_CAPITAL_RETURN:
                return "CC";
            case BasisOfQuotation.EX_CAPITAL_RETURN:
                return "XC";
            case BasisOfQuotation.CUM_DIVIDEND:
                return "CD";
            case BasisOfQuotation.EX_DIVIDEND:
                return "XD";
            case BasisOfQuotation.CUM_ENTITLEMENT:
                return "CE";
            case BasisOfQuotation.EX_ENTITLEMENT:
                return "XE";
            case BasisOfQuotation.CUM_EQUAL_ACCESS_SCHEME:
                return "CQ";
            case BasisOfQuotation.EX_EQUAL_ACCESS_SCHEME:
                return "XQ";
            case BasisOfQuotation.CUM_INTEREST:
                return "CI";
            case BasisOfQuotation.EX_INTEREST:
                return "XI";
            case BasisOfQuotation.CUM_PRIORITY:
                return "CZ";
            case BasisOfQuotation.EX_PRIORITY:
                return "XZ";
            case BasisOfQuotation.CUM_RIGHTS_ISSUE:
                return "CR";
            case BasisOfQuotation.EX_RIGHTS_ISSUE:
                return "XR";
            case BasisOfQuotation.CUM_TAKEOVER_OFFER:
                return "CF";
            case BasisOfQuotation.EX_TAKEOVER_OFFER:
                return "XF";
            case BasisOfQuotation.NEW_EX_INTEREST:
                return "NX";
            case BasisOfQuotation.PROTECTION_AVAILABLE:
                return "PA";
            case BasisOfQuotation.PROTECTION_UNAVAILABLE:
                return "PU";
            case BasisOfQuotation.RECONSTRUCTED:
                return "RE";
            default:
                return basis;
        }
    };
}
